import { useEffect, useRef, useState } from 'react';
import { useTeleSession } from '@shareview/tele-engine-react';
import { compactLine, toRows, type ByteHistory, type StatsRow } from './stats';

/** Polls `session.getStats()` every second while enabled; logs a compact line every 5 s. */
export function useCallStats(enabled: boolean): StatsRow[] | undefined {
  const session = useTeleSession();
  const [rows, setRows] = useState<StatsRow[]>();
  const history = useRef<ByteHistory>(new Map());

  useEffect(() => {
    if (!enabled) return undefined;
    history.current = new Map();
    let tick = 0;
    let cancelled = false;
    const id = window.setInterval(async () => {
      const samples = await session.getStats().catch(() => []);
      if (cancelled) return;
      const snapshot = session.getSnapshot();
      const next = toRows(samples, snapshot, history.current);
      setRows(next);
      if (++tick % 5 === 0) {
        console.log(compactLine(snapshot.state, snapshot.remoteParticipants.length + 1, next));
      }
    }, 1000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [session, enabled]);

  return enabled ? rows : undefined;
}
